import { render, staticRenderFns } from "./mailMessageCard.vue?vue&type=template&id=b0e40838"
import script from "./mailMessageCard.vue?vue&type=script&lang=ts"
export * from "./mailMessageCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports